import { TableCell, TableRow } from '@carbon/react';
import styles from '../allocation-manager.module.scss';
import { AllocationManagerLineItemsRowsProps } from 'pages/development-areas/show/allocation-manager-types';
import { LineItemValueCell } from './line-item-value-cells';

export const AllocationManagerLineItems = ({
  items,
  renderLateralLengthValues,
  onLineItemClick,
  selectedTractId,
}: AllocationManagerLineItemsRowsProps) => {
  // Sort items alphabetically by tract name
  const sortedItems = [...items].sort((a, b) => {
    return a.unitAllocationTract.tractName.localeCompare(
      b.unitAllocationTract.tractName,
      undefined,
      {
        numeric: true,
        sensitivity: 'base',
      }
    );
  });

  return (
    <>
      {sortedItems.map((item, index) => (
        <TableRow
          key={index}
          onClick={() =>
            onLineItemClick?.(
              item.unitAllocationTract.id === selectedTractId
                ? null
                : item.unitAllocationTract.id
            )
          }
          className={`${styles.tableRow} ${
            item.unitAllocationTract.id === selectedTractId
              ? styles.selectedRow
              : ''
          }`}
          style={{ cursor: 'pointer' }}
        >
          <TableCell className={`${styles.well} ${styles.firstChild}`}>
            {item.unitAllocationTract.tractName}
          </TableCell>
          <LineItemValueCell
            className={styles.leftBorder}
            value={item.unitAllocationTractAcreageValue}
          />
          <LineItemValueCell
            value={item.unitAllocationTractAcreageFactor * 100}
            isPercentage
          />
          <LineItemValueCell value={item.unitAllocationTract.gisAcres} />
          {renderLateralLengthValues ? (
            <>
              <LineItemValueCell
                className={styles.leftBorder}
                value={item.unitAllocationTractLateralValue}
              />
              <LineItemValueCell
                value={item.unitAllocationTractLateralFactor * 100}
                isPercentage
              />
              <LineItemValueCell
                value={item.unitAllocationTractLateralGisValue}
              />
            </>
          ) : index === 0 ? (
            <TableCell
              colSpan={3}
              {...({ rowSpan: items.length + 2 } as any)}
              className={`${styles.lateralLengthAlert}`}
            >
              <div className={styles.messageContainer}>
                <p>
                  <strong>This unit is allocated based on acreage</strong>
                </p>
                <p>Please refer to the left panel</p>
              </div>
            </TableCell>
          ) : null}
        </TableRow>
      ))}
    </>
  );
};
